module.exports = __webpack_public_path__ + "img/tks_xg.e4e1f1da.png";